<!-- ============================================================== -->
<!-- Fixed height Card Grid-->
<!-- ============================================================== -->
<div class="row">
		<div class="col-12" >
				<mat-card>
						<mat-card-content>
							<mat-card-title>Basic Progress spinner</mat-card-title>
							<mat-card-subtitle><code>&lt;mat-progress-spinner&gt;</code> are a circular indicators of progress and activity.</mat-card-subtitle>
							<mat-spinner></mat-spinner>  
						</mat-card-content>        
				</mat-card>
		</div> 
</div>    
<!-- ============================================================== -->
<!-- Basic Card Grid-->
<!-- ============================================================== -->
<mat-card class="example-card">
	<mat-card-content>
	  <h2 class="example-h2">Progress spinner configuration</h2>
  
	  <section class="example-section">
		<label class="example-margin">Color:</label>
		<mat-radio-group [(ngModel)]="color">
		  <mat-radio-button class="example-margin" value="primary">
			Primary
		  </mat-radio-button>
		  <mat-radio-button class="example-margin" value="accent">
			Accent
		  </mat-radio-button>
		  <mat-radio-button class="example-margin" value="warn">
			Warn
		  </mat-radio-button>
		</mat-radio-group>
	  </section>
  
	  <section class="example-section">
		<label class="example-margin">Mode:</label>
		<mat-radio-group [(ngModel)]="mode">
		  <mat-radio-button class="example-margin" value="determinate">
			Determinate
		  </mat-radio-button>
		  <mat-radio-button class="example-margin" value="indeterminate">
			Indeterminate
		  </mat-radio-button>
		</mat-radio-group>
	  </section>
  
	  <section class="example-section" *ngIf="mode === 'determinate'">
		<label class="example-margin">Progress:</label>
		<mat-slider class="example-margin">
		  <input type="range" [(ngModel)]="value" matSliderThumb>
		</mat-slider>
	  </section>
	</mat-card-content>
  </mat-card>
  
  <mat-card class="example-card">
	<mat-card-content>
	  <h2 class="example-h2">Result</h2>
  
	  <mat-progress-spinner
		  class="example-margin"
		  [color]="color"
		  [mode]="mode"
		  [value]="value">
	  </mat-progress-spinner>
	</mat-card-content>
  </mat-card>
  
